import { Shark, SmartModel, Utils } from "shark-mvc";

class ApplicatorTimeRange extends SmartModel {
	applicatorTeamGuid = "";
	dateEnd = "0000-00-00 00:00:00";
	dateStart = "0000-00-00 00:00:00";
	guid = "";
	notes = "";
	status = 1;

	__constructionApplicatorTeam = "";
	__dateEnd = "";
	__dateStart = "";

	constructor (data) {
		super();

		if (data) {
			this.import(data);
		}
	}

	export () {
		const exportData = this.__export();

		exportData.dateEnd = this.exportDateField("dateEnd");
		exportData.dateStart = this.exportDateField("dateStart");

		return exportData;
	}

	evaluateApplicatorName () {
		const applicatorTeamList = Shark.get("applicatorTeamList");

		if (applicatorTeamList) {
			const currApplicatorTeam = Utils.safp(applicatorTeamList, "guid", this.applicatorTeamGuid);

			if (currApplicatorTeam) {
				this.__constructionApplicatorTeam = currApplicatorTeam.name;
			}
		}
	}

	import (data, options) {
		this.__import(data, options);

		this.importNumberField("status", data.status);
		
		if (this.importDateField("dateEnd", data.dateEnd)) {
			this.__dateEnd = this.dateEnd.format("YYYY-MM-DD");
			this.__dateEndLabel = this.dateEnd.format("DD/MM/YYYY");
		}

		if (this.importDateField("dateStart", data.dateStart)) {
			this.__dateStart = this.dateStart.format("YYYY-MM-DD");
			this.__dateStartLabel = this.dateStart.format("DD/MM/YYYY");
		}

		this.evaluateApplicatorName();
	}
}

Shark.registerModel("ApplicatorTimeRange", ApplicatorTimeRange);

export default ApplicatorTimeRange;
